import styled from 'styled-components';

const ImagesContainer = styled.div`
  width: 100%;
  height: 100vh;
`;

export default ImagesContainer;
